import { zipCodeFormat, zipCodeNormalize } from 'common/helpers/addresses';
import {
  convertDayMonthYearToDate,
  isDayMonthYearADate
} from 'common/helpers/dateHelper';
import { phoneFormat, phoneFormatForDB } from 'common/helpers/phoneHelper';

export const transformAddressData = (values) => {
  const data = {
    firstName: values.firstName,
    lastName: values.lastName,
    company: values.company,
    address: values.address,
    address2: values.address2,
    city: values.city,
    stateCode: values.stateCode,
    zipCode: zipCodeNormalize(values.zipCode, values.countryCode),
    phone: phoneFormatForDB(values.phone, values.countryCode),
    countryCode: values.countryCode
  };
  const { birthDay, birthMonth, birthYear } = values;
  if (isDayMonthYearADate(birthDay, birthMonth, birthYear)) {
    data.birthDate = convertDayMonthYearToDate(birthDay, birthMonth, birthYear);
  }
  return data;
};

export const initialFormValues = (address) => {
  const initialValues = { ...address };
  if (initialValues) {
    if (initialValues.birthDate) {
      initialValues.birthDay = initialValues.birthDate.substring(8, 10);
      initialValues.birthMonth = initialValues.birthDate.substring(5, 7);
      initialValues.birthYear = initialValues.birthDate.substring(0, 4);
    }
    initialValues.phone = phoneFormat(
      initialValues.phone,
      initialValues.countryCode
    );
    initialValues.zipCode = zipCodeFormat(
      initialValues.zipCode,
      initialValues.countryCode
    );
  }
  return initialValues;
};

export const addressOneLine = (address) =>
  `${address.address}, ${address.city}, ${address.stateCode}, ${address.zipCode}, ${address.countryCode}`;
